import React from "react";
import {
    LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend
} from "recharts";
import "./PriceForecastChart.css";

const PriceForecastChart = ({ data, loading}) => {
    const preparedData = transformDtoToChartData(data);
    return (
        <div className="chart-container">

            {loading ? (
                <div className="loader-wrapper">
                    <div className="loader" />
                </div>
            ) : (
                <ResponsiveContainer width="100%" height="100%">
                    <LineChart data={preparedData} margin={{ top: 20, right: 30, left: 0, bottom: 5 }}>
                        <CartesianGrid stroke="#eee" strokeDasharray="5 5" />
                        <XAxis dataKey="date" />
                        <YAxis />
                        <Tooltip />
                        <Legend />

                        {/* Чистый прогноз */}
                        <Line type="monotone" dataKey="clean" stroke="#007aff" dot={false} name="Финальный прогноз" />

                        {/* Сырой прогноз */}
                        <Line type="monotone" dataKey="raw" stroke="#ff7300" dot={false} name="Сырой прогноз" />

                        {/* Нижняя граница */}
                        <Line type="monotone" dataKey="min" stroke="#00c853" dot={false} strokeDasharray="5 5" name="Нижняя граница" />

                        {/* Верхняя граница */}
                        <Line type="monotone" dataKey="max" stroke="#d50000" dot={false} strokeDasharray="5 5" name="Верхняя граница" />
                    </LineChart>
                </ResponsiveContainer>
            )}
        </div>
    );
};

function transformDtoToChartData(dto) {
    console.log(dto)
    const result = dto?.result || {};
    const rawPrices = dto?.rawData?.rawPrices || {};
    const boards = dto?.rawData?.boards || {};

    const allDates = Array.from(
        new Set([
            ...Object.keys(result),
            ...Object.keys(rawPrices),
            ...Object.keys(boards)
        ])
    ).sort();

    return allDates.map(date => ({
        date,
        clean: result[date] ?? null,
        raw: rawPrices[date] ?? null,
        min: boards[date]?.min ?? null,
        max: boards[date]?.max ?? null,
    }));
}

export default PriceForecastChart;
